import { PAGE_TYPE, BROWSE_TYPES } from 'dibs-constants/exports/pageTypes';
import { canAutoPromptUser, openLoginModal } from '../../helpers/loginPromptHelpers';

/**
 * Checks condition for auto prompt user.
 * Opens modal if condition is satisfied.
 * Condition:
 * page view >= 2,
 * home / browse / creator / pdp (not print) page type,
 * page is not loaded from EmailTokenLogin email
 * User is not logged in and AuthModal is not opened,
 * on every @param SESSIONS_COUNT session(@param {visitCountModel.get('sessionVisitCount')}) until @param {localStorage.getItem(KEY_REG_PROMPT_COUNT)} === @param MODAL_LIMIT .
 *
 * @return {Promise}
 */
const loginPromptRule = function loginPromptRule(): Promise<boolean> {
    return Promise.resolve(canAutoPromptUser());
};

export default {
    name: 'loginPrompt',
    rule: loginPromptRule,
    action: openLoginModal,
    allowedPageTypes: [
        PAGE_TYPE.HOME,
        PAGE_TYPE.CREATOR,
        PAGE_TYPE.DEALER,
        PAGE_TYPE.PDP,
        PAGE_TYPE.SEARCH,
        ...BROWSE_TYPES,
    ],
    priority: 250,
};
